import React, {useState} from "react";
import styles from "../../../Tab.module.scss";
import {useRouteLoaderData} from "react-router-dom";
import {ICustomer} from "../../../../model";
import {CamerasSection} from "../../../cameras/CamerasSection";


const CustomerAssetsTab = () => {
    const customer = useRouteLoaderData('customer-info') as ICustomer;
    const [activeInnerTab, setActiveInnerTab] = useState('Cameras');
    const innerNavLinks = ['Cameras'];

    const renderInnerContent = () => {
        switch (activeInnerTab) {
            case 'Cameras':
                return <CamerasSection customer={customer}/>;
            default:
                return <div>Not found {activeInnerTab}</div>;
        }
    };

    return (
        <div className={styles.detailsLayout}>
            {innerNavLinks.length > 1 &&
            <nav className={styles.innerSidebar}>
                <ul>
                    {innerNavLinks.map((tabName) => (
                        <li key={tabName}>
                            <button
                                className={activeInnerTab === tabName ? styles.active : ''}
                                onClick={() => setActiveInnerTab(tabName)}
                            >
                                {tabName}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
            }
            <div className={styles.contentWrapper}>
                <h2 style={{fontWeight: 400}}>{activeInnerTab}</h2>
                {renderInnerContent()}
            </div>
        </div>
    );
}

export default CustomerAssetsTab;
